var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignupUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Frame"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M11.3333 5.66667C11.3333 3.82572 9.84093 2.33333 8 2.33333C6.15905 2.33333 4.66667 3.82572 4.66667 5.66667C4.66667 7.5076 6.15905 9 8 9C9.84093 9 11.3333 7.5076 11.3333 5.66667Z",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M12.6667 13.6667C12.6667 11.0893 10.5773 9 8 9C5.42267 9 3.33333 11.0893 3.33333 13.6667",
  stroke: "#A69782",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignupUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signup-user.3fe71bdb81a78d5bcc49647b6bb18ff5.svg";